import cookie from "react-cookies"
import { Navigate, useNavigate } from "react-router-dom"
import { store, useAppSelector } from "@/core/root-reducer"
import { ACCOUNT_DEMO } from "@/redux/account.types"
import LoginModal from "@/modals/login.modal"
import SupervisorDemoPrepareRoute from "./supervisor-demo-prepare.route"

interface Props {
  destination: "demo-account" | "demo-prepare"
}

export default function SupervisorDemoRoute({ destination }: Props) {
  const navigate = useNavigate()
  const session = useAppSelector((state) => state._session)
  const token = cookie.load("idtreeToken")
  const isSupervisor = session.interfaceType === "SUPERVISOR" || session.connectedAsSupervisor

  if (!token || token === "null" || !isSupervisor) {
    return <Navigate to={`/login/supervisor?next=${destination}`} replace />
  }

  if (destination === "demo-prepare") return <SupervisorDemoPrepareRoute />
  if (session.accountId === ACCOUNT_DEMO.id) return <Navigate to="/home" replace />

  return (
    <LoginModal
      authLevel={2}
      isSupervisor
      accountIdForSuperadmin={ACCOUNT_DEMO.id}
      email={session.email}
      onClose={() => {
        if (store.getState()._session.accountId !== ACCOUNT_DEMO.id) {
          navigate("/supervisor/accounts", { replace: true })
        }
      }}
    />
  )
}
